import * as yup from "yup";

export const schema = (t: (val: string) => string) => {
    const validation = {
        name: yup.string().required(t("cmn:val.required")),
        service: yup.string().required(t("cmn:val.required")),
        training: yup.string().required(t("cmn:val.required")),
        trainingYears: yup
            .array()
            .of(yup.string())
            .min(1, t("cmn:val.required")),
        typology: yup.string().required(t("cmn:val.required")),
        // years: yup.array().of(yup.string()).min(1, t("cmn:val.required")),
    };

    return yup.object().shape({ ...validation });
};
